const events = JSON.parse(localStorage.getItem('eventsStorage'));
const amount = localStorage.getItem('betslipStorageAmount');
const type = localStorage.getItem('betslipStorageType');

const state = {
  events: events ? events : [],
  type: type ? type : 'single',
  odd_change: false,
  error_message: '',
  amount: amount ? amount : "1.00"
}
const getters = {
  events(state) {
    return state.events
  },
  type(state) {
    return state.type
  },
  error_message(state) {
    return state.error_message
  },
  amount(state) {
    return state.amount
  },
  odd_change(state) {
    return state.odd_change
  },
}
const mutations = {
  SET_COUPON(state, payload){
    state.events = payload;
  },
  ADD_EVENT(state, payload){
    state.events.push(payload);
  },
  REMOVE_EVENT(state, payload){
    state.events.splice(payload, 1);
  },
  SET_ERRORS(state, payload){
    state.error_message = payload;
  },
  SET_TYPE(state, payload){
    state.type = payload;
    localStorage.setItem('betslipStorageType', payload);
  },
  ODD_CHANGE(state, payload){
    state.odd_change = payload;
  },
  SET_AMOUNT(state, payload){
    payload = parseFloat(payload).toFixed(2);
    state.amount = payload;
    localStorage.setItem('betslipStorageAmount', payload);
  },
}
const actions = {
  create({ commit, state, dispatch }, payload){
    commit('SET_ERRORS', []);
    return axios.post('/user/coupons/create', { ...payload })
    .then((response)=>{
      //console.log(response.data)
      if(response.data.accept){
        dispatch('clear')
        dispatch('alert/message', { type: 'success', title: 'coupon.coupon_success'}, { root: true })
      }else{
        commit('SET_ERRORS', response.data.reason);
      }
    })
    .catch(() => {})
    .finally(() => {
    });
  },
  add({ commit, state }, payload){
    if(_.find(state.events, function(o) 
      { return o.eid == payload.eid && o.marketId == payload.marketId && o.oddId == payload.oddId && o.sbv == payload.sbv}))
    {
      let index = _.findIndex(state.events, function(o) { return o.eid == payload.eid && o.marketId == payload.marketId && o.oddId == payload.oddId && o.sbv == payload.sbv });
      
      state.events.splice(index, 1);
      
      localStorage.setItem('eventsStorage', JSON.stringify(state.events));

      return false;
      
    }
    if(state.type == 'single'){
      commit('ADD_EVENT', payload)
    }else if (state.type == 'combine'){
      if(!_.find(state.events, function(o) { return o.eid == payload.eid; })){
        commit('ADD_EVENT', payload)
      }
    }
    
    commit('SET_ERRORS', []);
    localStorage.setItem('eventsStorage', JSON.stringify(state.events));
  },
  remove({ commit, state }, payload){
    commit('SET_ERRORS', []);
    commit('REMOVE_EVENT', payload)
    localStorage.setItem('eventsStorage', JSON.stringify(state.events));
  },
  clear({ commit, state }){
    commit('SET_COUPON', [])
    commit('SET_ERRORS', []);
    commit('SET_TYPE', 'single')
    localStorage.removeItem('eventsStorage');
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}